import { http, HttpResponse, delay } from 'msw';

import {
  addOnsList,
  hecOverview,
  hecThreats,
  malwarebytesDevices,
  malwarebytesOverview,
} from '../data/addOnDtoData';
import { simpleOrganization } from '../data/organizationData';

export const addOnHandlers = [
  http.get('*/v1/add_ons', async () => {
    await delay();
    return HttpResponse.json(addOnsList, { status: 200 });
  }),

  http.post(
    '*/v1/organizations/:id/add_ons/send_add_on_interest_email',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),
  http.post(
    '*/v1/organizations/:id/add_ons/send_learn_more_about_security_email',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  http.get('*/v1/organizations/:id/add_ons/malwarebytes/overview', async () => {
    await delay();
    return HttpResponse.json(malwarebytesOverview, { status: 200 });
  }),
  http.get('*/v1/organizations/:id/add_ons/malwarebytes/devices', async () => {
    await delay();
    return HttpResponse.json(malwarebytesDevices, { status: 200 });
  }),
  http.get('*/v1/organizations/:id/add_ons/hec/overview', async () => {
    await delay();
    return HttpResponse.json(hecOverview, { status: 200 });
  }),
  http.get('*/v1/organizations/:id/add_ons/hec/threats', async () => {
    await delay();
    return HttpResponse.json(hecThreats, { status: 200 });
  }),

  http.post('*/v1/organizations/:id/add_ons', async () => {
    await delay();
    return HttpResponse.json(simpleOrganization, { status: 200 });
  }),
  http.patch('*/v1/organizations/:id/add_ons/:addOnId', async () => {
    await delay();
    return HttpResponse.json(simpleOrganization, { status: 200 });
  }),
  http.delete('*/v1/organizations/:id/add_ons/:addOnId', async () => {
    await delay();
    return HttpResponse.json(simpleOrganization, { status: 200 });
  }),
];
